import { AS, checkExpDate  } from "../config/account"
import { NOT_SET } from "../config/accountSubscription"
import { setAccount } from "../Firebase/apiAccount"

const ACCOUNT_INFO_RECEIVE = 'ACCOUNT_INFO_RECEIVE'
const ACCOUNT_ON_INCREASE_COUNT = 'ACCOUNT_ON_INCREASE_COUNT'
const ACCOUNT_REG_DATA_CHANGED = 'ACCOUNT_REG_DATA_CHANGED'
const ACCOUNT_ON_ORDER = 'ACCOUNT_ON_ORDER'

export const accountInfoReceive = account => {
  const { as, exd, o } = account
  const resAccount = checkExpDate(as, exd, o)
  if (resAccount.as !== as) {
    return (dispatch) => {
      setAccount({ ...account, ...resAccount }, dispatch, onAccountInfoReceive)
    }
  }
  return (dispatch) => {
    dispatch(onAccountInfoReceive(account))
  }
}

export const onAccountInfoReceive = account => {
  return {
    type: ACCOUNT_INFO_RECEIVE,
    account: account
  }
}

export const onIncreaseCount = (accountInfo, count) => {
  return {
    type: ACCOUNT_ON_INCREASE_COUNT,
    info: accountInfo,
    count: count
  }
}

export const onAccountRegDataChanged = regData => {
  return {
    type: ACCOUNT_REG_DATA_CHANGED,
    regData: regData
  }
}

export const onOrder = (accounState) => {
  return {
    type: ACCOUNT_ON_ORDER,
    as: accounState
  }
}

const initState = {
  as: AS.DEMO,
  c: 0,
  exd: '',
  o: false,
  regData: {
    orderNo: 0,
    subscription: NOT_SET,
    prevSubscription: NOT_SET,
    name: '',
    address: '',
    ico: '',
    dic: '',
    email: '',
    acceptCondition: false
  }
}

export default (state = initState, action) => {
  if (action.type === ACCOUNT_INFO_RECEIVE) {
    return {
      ...state,
      ...action.account
    }
  }
  if (action.type === ACCOUNT_ON_INCREASE_COUNT) {
    const { info, count } = action
    return {
      ...state,
      as: info.as,
      c: count,
      o: info.o
    }
  }
  if (action.type === ACCOUNT_REG_DATA_CHANGED) {
    return {
      ...state,
      regData: { ...action.regData }
    }
  }
  if (action.type === ACCOUNT_ON_ORDER) {
    return {
      ...state,
      as: action.as
    }
  }
  return state
}



// WEBPACK FOOTER //
// ./src/reducers/account.js